import { render, staticRenderFns } from "./viewRemittance.vue?vue&type=template&id=f6bf105e&scoped=true&"
import script from "./viewRemittance.vue?vue&type=script&lang=js&"
export * from "./viewRemittance.vue?vue&type=script&lang=js&"
import style0 from "./viewRemittance.vue?vue&type=style&index=0&id=f6bf105e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bf105e",
  null
  
)

export default component.exports